export default __webpack_public_path__ + "static/media/people2small.3e96bfad.jpg";